import { Children, isValidElement, type ReactElement, type ReactNode } from 'react';

import { End, type EndProps } from './End';
import { Start, type StartProps } from './Start';

type FooterProps = {
  children?: ReactNode;
};

const findSlotContent = (nodes: ReactNode | undefined, Slot: typeof Start | typeof End) => {
  const match = Children.toArray(nodes).find(child => isValidElement(child) && child.type === Slot);

  if (!match) {
    return undefined;
  }

  return (match as ReactElement<StartProps | EndProps>).props.children;
};

export const Footer = ({ children }: FooterProps) => {
  const start = findSlotContent(children, Start);
  const end = findSlotContent(children, End);

  if (!start && !end) {
    return (
      <footer className='flex w-full flex-col gap-3 border-t border-t-(--uizz-antd-color-split) pt-5'>
        {children}
      </footer>
    );
  }

  return (
    <footer className='grid w-full grid-cols-2 gap-1 border-t border-t-(--uizz-antd-color-split) pt-5'>
      <div className='flex justify-start gap-2'>{start}</div>
      <div className='flex justify-end gap-2'>{end}</div>
    </footer>
  );
};

Footer.Start = Start;
Footer.End = End;
